<h2 mat-dialog-title>{{'TREATMENT.QUERY_DIALOG.TITLE' | translate}}</h2>
<form [formGroup]="form">
  <mat-dialog-content>
    <div class="layout-row-grow">
      <div class="query-form flex-50">
        <mat-form-field>
          <mat-label>{{'TREATMENT.QUERY_DIALOG.ORGANISATION' | translate}}</mat-label>
          <input matInput formControlName="organisationId" required autocomplete="off">
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{'TREATMENT.QUERY_DIALOG.TREATMENT' | translate}}</mat-label>
          <input matInput formControlName="processingKey" required autocomplete="off">
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{'TREATMENT.QUERY_DIALOG.USER_ID' | translate}}</mat-label>
          <input matInput formControlName="userId" required autocomplete="off">
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{'TREATMENT.QUERY_DIALOG.DATE' | translate}}</mat-label>
          <input matInput formControlName="date">
        </mat-form-field>
        <button mat-flat-button type="button" color="primary" cdkFocusInitial (click)="submit()"
          [disabled]="form.invalid">
          {{'COMMON.BUTTONS.SUBMIT' | translate}}
        </button>
      </div>
      <div class="query-result flex-50">
        @if (loading) {
        <mat-spinner [diameter]=15></mat-spinner>
        } @else {
        @if (result !== undefined) {
        <mat-list>
          <mat-list-item>
            <span class="result-label">{{'TREATMENT.QUERY_DIALOG.ID' | translate}}</span>
            <span class="result-value">{{result.queryId}}</span>
          </mat-list-item>
          <mat-list-item>
            <span class="result-label">{{'TREATMENT.QUERY_DIALOG.DATE' | translate}}</span>
            <span class="result-value">{{result.queryDate | date}}</span>
          </mat-list-item>
          <mat-list-item>
            <span class="result-label">{{'TREATMENT.QUERY_DIALOG.EXECUTION_TIME' | translate}}</span>
            <span class="result-value">{{result.queryTime}} ms</span>
          </mat-list-item>
          <mat-list-item>
            <span class="result-label">{{'TREATMENT.QUERY_DIALOG.SERIAL' | translate}}</span>
            <span class="result-value">
              {{result.evaluations[0]?.consent.serial ? result.evaluations[0]?.consent.serial :
              ('TREATMENT.QUERY_DIALOG.MISSING' | translate)}}
            </span>
          </mat-list-item>
          <mat-list-item align="center">
            <mat-chip-listbox class="mat-chip-list-stacked">
              @if (result.evaluations[0].evaluation) {
              <mat-chip-option color="primary">
                {{'TREATMENT.QUERY_DIALOG.AUTHORIZED' | translate}}
              </mat-chip-option>
              }
              @if (!result.evaluations[0].evaluation) {
              <mat-chip-option color="warn">
                {{'TREATMENT.QUERY_DIALOG.REFUSED' | translate}}
              </mat-chip-option>
              }
            </mat-chip-listbox>
          </mat-list-item>
        </mat-list>
        } @else {
        <div>{{'TREATMENT.QUERY_DIALOG.NO_RESULT' | translate}}</div>
        }
        }
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="btn-uppercase align-right">
    <button mat-button type="button" color="primary" (click)="close()">
      {{'COMMON.BUTTONS.CLOSE' | translate}}
    </button>
  </mat-dialog-actions>
</form>